import { Component, EventEmitter, HostBinding, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-work-item-interaction',
  templateUrl: './workitem-interaction.component.html',
  styleUrls: ['./workitem-interaction.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WorkitemInteractionComponent {
  @HostBinding('class.interaction')
  readonly interactionClass = true;
  @Output()
  accept = new EventEmitter<MouseEvent>();
}
